import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  Box
} from "@mui/material";
import { Link } from "react-router-dom";
import { withRouter } from "../../../providers/withRouter";
import { UsuarioContext } from "../../../providers/userContext";
import { DataTable } from "../../../components";
import { useComunidades } from "../../../hooks";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import FiltrosComunidadesTech from '../../../components/filtros/filtrosComunidadesTech';

import { useLocation, useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';

const Comunidades = (props) => {
  const { t } = useTranslation(['properties', 'aaff', 'common']);

  const comunidadesRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('aaff:titleSingular').toUpperCase(),
      noObjeto:true,
    },
    {
      id: "community",
      numeric: false,
      disablePadding: false,
      noObjeto:true,
      label: t('columns.community'),
      overrideFunc: (data, row) => (
        <Link to={`/aaff/${row.aaff_nif}/comunidades/${row.nif}`}>
          {data}
        </Link>
      )
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('columns.nif'),
    },
    {
      id: "direccion",
      numeric: false,
      disablePadding: false,
      label: t('columns.address'),
    },
    {
      id: "codigoPostal",
      numeric: false,
      disablePadding: false,
      label: t('columns.postalCode'),
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('columns.municipality'),
    },

  ];

  
  // const { loading, data, fetchData} = useComunidades(props.params.nif );
  const { loading, data, fetchData, aaffs } = useComunidades();
  console.log("data",data);
  const {filtrosIniciales} = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  // const [busqueda, setBusqueda] = useState({ nifAAFF: props.params.nif });
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [recargar, setRecargar] = useState(0);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);

  const handleFetchData = async ({ offset, limit,order, orderBy }) => {


    try {
      await fetchData({ offset, limit, filtros: busqueda ,order, orderBy});
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  }


  useEffect(() => {
    setRecargar(false);
  }, [recargar]);

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros)
    setBusquedaActiva(true);
    // fetchData({ offset: 1, limit: limite, filtros: filtros });
  }

  return (
    <>

      <BreadCrumb
        rutas={[{ path: "/comunidades", label: t('title') }]}
        style={{ margin: "0 10px" }}
      />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('details.generalInfo')}
          </div>
          <div className="pageContent tableContainer">
            <FiltrosComunidadesTech onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} aaffsData={aaffs} />
            <Box>
              <Box sx={{ mb: 10 }}>
                <DataTable
                  data={data?.rows}
                  isLoading={loading}
                  headers={comunidadesRows}
                  fetcher={handleFetchData}
                  currentPage={data.current_page}
                  meta={data?.meta}
                  totalItems={data.total}
                  totalPages={data.totalPages}
                  nextPage={data.next_page}
                  filtros={busqueda}
                  busquedaActiva={busquedaActiva}
                  setBusquedaActiva={setBusquedaActiva}
                  clearFilterActivo={clearFilterActivo}
                  setClearFilterActivo={setClearFilterActivo}
                  mensaje={t('noCommunities')}
                >
                </DataTable>
              </Box>
            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Comunidades);
